import React from 'react'
import { useDispatch } from 'react-redux'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import clsx from 'clsx'
import {
  resetCSVFileData,
  setIsOpenDeleteCSVFileDialog,
  useImportCSVData,
} from 'app/store/importCSV'
import CancelButton from 'app/components/buttons/CancelButton'
import DeleteButton from 'app/components/buttons/DeleteButton'

import useStyles from './styles'

const DialogDeleteCSVFile = () => {
  const dispatch = useDispatch()
  const {
    data: { fileName },
    isOpenDeleteCSVFileDialog,
  } = useImportCSVData()

  const classes = useStyles()

  const closeDialog = () => {
    dispatch(setIsOpenDeleteCSVFileDialog(false))
  }

  const deleteCSVFile = () => {
    dispatch(resetCSVFileData())
  }

  return (
    <Dialog
      className={clsx(classes.deleteDialog)}
      open={isOpenDeleteCSVFileDialog}
    >
      <DialogTitle className={classes.deleteDialogTitle}>
        <FormattedMessage id="subscribers.import.dialogDeleteCSVFile.title" />
      </DialogTitle>
      <DialogContent className={classes.deleteDialogContent}>
        <FormattedMessage
          id="subscribers.import.dialogDeleteCSVFile.description"
          values={{ fileName }}
        />
      </DialogContent>
      <DialogActions className={classes.deleteDialogActions}>
        <CancelButton
          labelId="text.close"
          onClick={closeDialog}
          variant="outlined"
          className={classes.cancelBtn}
        />
        <DeleteButton onClick={deleteCSVFile} />
      </DialogActions>
    </Dialog>
  )
}

export default DialogDeleteCSVFile
